import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import "../styles/AboutHero.css";

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

export default function HeroSection() {
  return <section className="about-hero-section"></section>;
}
